(function() {
    BounceCategories.$inject = ['$scope', '__env', 'toastr', 'httpService', '$log'];

    angular
    	.module('app')
    	.component('bounceCategoriesComponent', {
    		templateUrl: 'modules/emailSending/components/bounceCategories/bounceCategories.html',
    		controller: BounceCategories
    	});

    /**
     * Code supporting the kendo grid that displays bounce categories 
     * and performs CRUD opperations
     *
     * @class BounceCategories
     * @param { service } $scope - The scope of the component.
     * @param { service } __env - The environment configuration. 
     * @param { service } toastr - The third party toaster service.
     * @param { service } httpService - The http service used to make asynchronous rest calls
     */
    function BounceCategories($scope, __env, toastr, httpService, $log) {	

        
    	// columns of the grid
    	var columns = [
    		{
    			field: 'code',
    			title: 'Code',
    			width: '30%'
    		}, 
    		{
    			field: 'description',
    			title: 'Description',
    			width: '30%'
    		}, 
    		{
    			field: 'isHardBounce',
    			title: 'Hard Bounce',
    			width: '12%'
    		},
    		{ 
    			command: ['edit', 'destroy'], 
    			title: '&nbsp;',
                hidden: !$scope.$parent.pagePermissions.write,
    			width: '18%'}
    	];

    	// model to bind to
    	var model = { id: 'id', 
    					fields : {
    						'code': { type: 'string' },
    						'description': { type: 'string' },
    						'isHardBounce': { type: 'boolean' }
    					}}; 

    	$scope.pageTitle = 'Bounce Categories';

    	$scope.categoriesOptions = { 
            columnMenu: false,        
            columns: columns,        
            editable: 'popup',   
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains',
                        eq: 'Is equal to'
                    }
                }
            },
            groupable: false,        
            pageable: true,
            remove: deleteEvent,
            save: saveEvent,
            scrollable: true,          
            sortable: true       
        };	

        // commented until the endpoints exist
        $scope.categoriesSource = 
        {	
        	//data: categories
    		type: 'aspnetmvc-ajax',		
            error: function(e) { toastr.error('Could not get categories');},	        
    		transport: {
    			read: {				
    				type: 'get',
    				contentType: 'application/json',	
    				url: __env.apiBounceCategories + 'paged/kendo'				              
    			}
    		},			
    		schema: {
                data: 'data',
                total: 'total',            
                model: model,                
            },                        
            pageSize: 20,        
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true        
    	};

    	/**
         * Triggers the new row add for a kendo grid.
         *
         * @function addNewCategory
         */
    	$scope.addNewCategory = function() {		

    		// trigger the add event 
    		this.categoriesGrid.addRow();
    	};

    	/**
         * Prepares the http request for adding a new category. Handles callbacks
         *
         * @function 
         * @param { object } category - category to be added
         */  
    	$scope.addCategory = function(category) {
    		var url = __env.apiBounceCategories;
    		var type = 'post';
    		var data = category;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Category successfully added');				
    				$scope.categoriesGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The Category could not be added');
                    var message = 'Status: ' + e.status + 
                                    '; Error:' + e.statusText;
                                    
                                    
                    $log.error(message);  
    				$scope.categoriesGrid.dataSource.read();
    			});			
    	};

    	/**
         * Prepares the http request for deleting a category. Handles callbacks
         *
         * @function 
         * @param { int } categoryId - id of category to be deleted
         */  
        $scope.deleteCategory = function(categoryId) {

        	var url = __env.apiBounceCategories + categoryId;
    		var type = 'delete';
    		var data = '';

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Category successfully deleted');				
    				$scope.categoriesGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The Category could not be deleted');
                    var message = 'Status: ' + e.status + 
                                    '; Error:' + e.statusText;
                                    
                                    
                    $log.error(message);  
    				$scope.categoriesGrid.dataSource.read();
    			});				
    	};

    	/**
         * handles save delete for the category grid.
         *
         * @function 
         * @param { event } e - delete row event
         */  
    	function deleteEvent(e) {
    		e.preventDefault();

    		$scope.deleteCategory(e.model.bounceCategoryId); 
    	}

    	/**
         * handles save event for the category grid.
         *
         * @function 
         * @param { event } e - save row event
         */  
    	function saveEvent(e) {

    		$scope.displayMode = true; 

    		// stop kendo from being annoying
    		e.preventDefault();

    		if(e.model.bounceCategoryId > 0) {

    			// categories with an id should be updated			
    			$scope.updateCategory(e.model);
    		} else {
    			e.model.bounceCategoryId = 0;

    			// categories without an id should be added
    			$scope.addCategory(e.model);
    		}
    	}

    	/**
         * Prepares the http request for updating a category. Handles callbacks.
         *
         * @function 
         * @param { obj } category - category object
         */   
        $scope.updateCategory = function(category) {   
        	var url = __env.apiBounceCategories + category.bounceCategoryId;
    		var type = 'put';
    		var data = category;

    		httpService.asyncCall(url, type, data)
    			.then(function(response) {
    				toastr.success('Category successfully updated');				
    				$scope.categoriesGrid.dataSource.read();
    			}).catch(function(e){
    				toastr.error('The Category could not be updated');
                    var message = 'Status: ' + e.status + 
                                    '; Error:' + e.statusText;
                                    
                                    
                    $log.error(message);  
    				$scope.categoriesGrid.dataSource.read();
    			});		
    		
        };
    }
})();